import React from 'react';
import { styled } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { Colors } from 'library';

interface RToastProps {
    message: string | null;
}

export function RToast({ message }: RToastProps) {
    if (!message) return null;
    return (
        <ToastContainer>
            <CheckCircle sx={{ fontSize: 22, color: Colors.darkNavy }} />
            {message}
        </ToastContainer>
    );
}

const ToastContainer = styled('div')({
    position: 'fixed',
    bottom: 24,
    right: 24,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    backgroundColor: Colors.white,
    color: Colors.darkNavy,
    padding: '16px 24px',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 500,
    border: `1px solid ${Colors.lightGrey}`,
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    zIndex: 2000,
    animation: 'toastFadeIn 0.2s ease-out',
    '@keyframes toastFadeIn': {
        from: { opacity: 0, transform: 'translateY(8px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
    },
});
